import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import { PositionDto } from './positionApi';
import { RoleDto } from './roleApi';
const FIDP_API_URL = config.servers.fidp.url;
export enum PasswordExpirationStatus {
  AVAILABLE = 'AVAILABLE', // 정상
  EXPIRED = 'EXPIRED', // 만료
  ALERT = 'ALERT', // 경고
}
export interface CodeName {
  code: string;
  name: string;
}
export interface UserSearchDto {
  count: number;
  users: UserDto[];
}
export interface UserDto {
  id: string; // 사용자 ID
  name: string; // 사용자 이름
  password: string; // 비밀번호
  email: string; // 사용자 이메일
  phoneNumber: string; // 핸드폰 번호
  depts: {
    primary: CodeName; // 기본 부서
    others: CodeName[]; // 겸직 부서
  };
  position: PositionDto; // 직급
  role: RoleDto; // 직무
  validityPeriod: {
    // 유효기간
    start: number; // 시작 일시 (-1: 무제한)
    end: number; //  종료 일시 (-1: 무제한)
  };
  useYN: 'Y' | 'N'; // 사용 여부
  passwordUpdatedTime: number; // 비밀번호 갱신 시간
  passwordStatus: PasswordExpirationStatus; // 비밀번호 상태
  initialPasswordYN: 'Y' | 'N'; // 비밀번호 초기화 여부
  updatedTime: number; // 수정 일시
  autoPassword: boolean; // 비밀번호 자동 부여
  dsdCode: string; // 도메인 코드
  linkedYN: 'Y' | 'N'; // 연동 여부
}
export interface UserInfoDto {
  user: {
    // 사용자
    id: string; // ID
    name: string; // 이름
    email: string; // 이메일
  };
  position: CodeName; // 직급
  role: CodeName; // 직무
  depts: {
    // 부서
    primary: DeptWithParents; // 기본 부서 with 상위 부서
    others: DeptWithParents[]; // 겸직 부서 with 상위 부서
  };
  managedDepts: CodeName[]; // 사용자가 부서장인 부서
}
interface DeptWithParents extends CodeName {
  // 기본 부서의 상위 부서 정보들. (범위: 기본 부서와 가까운 순서로 최상위 부서까지.)
  parents: Array<{
    level: number; // 기본 부서로부터 떨어진 거리. 1부터 시작.
    code: string; // 기본 부서의 상위 부서 코드
    name: string; // 기본 부서의 상위 부서 이름
  }>;
}
interface UserInfoEntity {
  [code: string]: UserInfoDto;
}
interface UserApi {
  userByIds(ids: string[]): Promise<UserSearchDto>;
  userById(id: string): Promise<UserSearchDto>;
  userByIdName(searchString: string): Promise<UserSearchDto>;
  userByIdNameInMyDept(searchString: string): Promise<UserSearchDto>;
  userInfo(id: string): Promise<UserInfoDto>;
  removeUsers(ids: string[]): Promise<void>;
}
class UserServerApi implements UserApi {
  async userByIds(ids: string[]): Promise<UserSearchDto> {
    const resp = await axios.get(
      `${FIDP_API_URL}/api/organs/userssearch?user_ids%5B%5D=${ids.join(',')}&limit=${ids.length}`
    );
    return resp.data;
  }
  async userById(id: string): Promise<UserSearchDto> {
    const resp = await axios.get(`${FIDP_API_URL}/api/organs/users?user_id=${id}`);
    return resp.data;
  }
  async userByIdName(searchString: string): Promise<UserSearchDto> {
    const resp = await axios.get(
      `${FIDP_API_URL}/api/organs/users?user_id_name=${encodeURIComponent(searchString)}`
    );
    return resp.data;
  }
  async userByIdNameInMyDept(searchString: string): Promise<UserSearchDto> {
    const resp = await axios.get(
      `${FIDP_API_URL}/api/organs/users?dept_scope=PRIMARY&user_id_name=${encodeURIComponent(
        searchString
      )}`
    );
    return resp.data;
  }
  async userInfo(id: string): Promise<UserInfoDto> {
    const resp = await axios.get(`${FIDP_API_URL}/api/organs/users/${id}/info`);
    return resp.data;
  }
  async removeUsers(ids: string[]): Promise<void> {
    await axios.delete(`${FIDP_API_URL}/api/organs/users`, {
      data: ids,
    });
  }
}
const userApi = new UserServerApi();
export default userApi;
